import {
  SET_PORTFOLIO_IDS_FILTER, SET_PORTFOLIO_GROUP_IDS_FILTER, LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS,
} from '../../../../constants/system/actions';

const portfolioFilterReducer: Reducer = (
  state: ReducerState = {
    portfolioIds: null,
    portfolioGroupIds: null,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case SET_PORTFOLIO_IDS_FILTER:
      return {
        ...state,
        portfolioIds: action.payload,
      };
    case SET_PORTFOLIO_GROUP_IDS_FILTER:
      return {
        ...state,
        portfolioGroupIds: action.payload,
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        portfolioIds: null,
        portfolioGroupIds: null,
      };
    default:
      return state;
  }
};

export default portfolioFilterReducer;
